export const SLICE_NAME = "auth";

const LOGIN = `${SLICE_NAME}/LOGIN`;
const SIGN_UP = `${SLICE_NAME}/SIGN_UP`;

export const actionTypes = {
  LOGIN,
  SIGN_UP,
};
